import { BottomFixedContainer } from "./BottomFixedContainer";
export default BottomFixedContainer;
